// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"dda19d59","178":"c4368e63","2410":"dda19d59","2989":"dda19d59","4869":"dda19d59","6343":"dda19d59","8225":"dda19d59","9497":"dda19d59"}[chunkId] + ".chunk.css";
};